@if (!isWallet) {
  <mat-icon class="payment-method__icon"
  aria-hidden="true">{{ isECheck ? 'account_balance' : 'credit_card' }}</mat-icon>
}

<!-- Wallet brand mark (Google Pay / Apple Pay) -->
@if (isWallet && walletMark === 'google-pay-mark') {
  <mat-icon
    svgIcon="google-pay-mark"
    class="payment-method__icon payment-method__icon--google-pay-mark"
    aria-hidden="true">
  </mat-icon>
}
@if (isWallet && walletMark === 'apple-pay-mark') {
  <mat-icon
    svgIcon="apple-pay-mark"
    class="payment-method__icon payment-method__icon--apple-pay-mark"
    aria-hidden="true">
  </mat-icon>
}

<!-- New payment method: simple label only -->
@if (label) {
  <span>{{label}}</span>
}

<!-- Saved payment method -->
@if (!label) {
  <!-- Compact label: used on narrow viewports and in summary context.
  Shows brand icon if known, otherwise falls back to text. -->
  @if ((appService.isNarrow || !forRadioButton) && !isECheck) {
    @if (paymentMethodsService.getPaymentIconFromString(cardType) === 'merchant-logos') {
      <mat-icon
        svgIcon="merchant-logos"
        class="merchant-logo"
        [ngClass]="paymentMethodsService.getMerchantLogoClass(cardType)"
        [attr.aria-label]="cardType">
      </mat-icon>
    }
    @if (paymentMethodsService.getPaymentIconFromString(cardType) !== 'merchant-logos') {
      <span>Credit</span>
    }
  }
  @if ((appService.isNarrow || !forRadioButton) && isECheck) {
    <span>E-Check </span>
  }
  <!-- Verbose label: used on wide viewports in radio button context only -->
  @if (!appService.isNarrow && forRadioButton) {
    <span>Pay with saved {{isECheck ? 'E-Check' : 'Credit Card'}}</span>
  }
  <!-- Masked card/account number. Middle dots (•) sit on the text centre line, so the
  mask aligns with the trailing digits — literal asterisks float toward the top. -->
  <span class="payment-method__number">
    {{isECheck ? '•' : (!forRadioButton || appService.isWide) ? '•••• •••• ' : ''}}•••• {{last4Digits}}
  </span>
  <!-- Brand logo after the number (wide radio button context only — compact label already shows it elsewhere) -->
  @if (appService.isWide && forRadioButton && !isECheck && cardType && paymentMethodsService.getPaymentIconFromString(cardType) === 'merchant-logos') {
    <mat-icon
      svgIcon="merchant-logos"
      class="merchant-logo"
      [ngClass]="paymentMethodsService.getMerchantLogoClass(cardType)"
      [attr.aria-label]="cardType">
    </mat-icon>
  }
}
